<template>
    <v-container>

        <v-row>
            
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">{{title}}</h2>
                        </v-col>
                    </v-row>

                    <v-row  class="search-container">

                        <v-col cols="12" sm="6" md="3">
                            <v-menu
                                v-model="showSearchStartDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="search.startDate ? $moment(search.startDate, $constants.DATE_PICKER_FORMAT).format($constants.DATE_FORMAT_NO_TIME) : null"
                                        label="Start Date"
                                        readonly
                                        prepend-icon="event"
                                        append-icon="close"
                                        @click:append="searchStartDateChanged(null)"
                                        v-on="on"
                                    >
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-if="showSearchStartDate"
                                    :value="search.startDate"
                                    @input="searchStartDateChanged($event)">
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-menu
                                v-model="showSearchEndDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="search.endDate ? $moment(search.endDate, $constants.DATE_PICKER_FORMAT).format($constants.DATE_FORMAT_NO_TIME) : null"
                                        label="End Date"
                                        readonly
                                        prepend-icon="event"
                                        append-icon="close"
                                        @click:append="searchEndDateChanged(null)"
                                        v-on="on"
                                    >
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-if="showSearchEndDate"
                                    :value="search.endDate"
                                    @input="searchEndDateChanged($event)">
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-select
                                :items="species"
                                item-text="SpeciesFullName"
                                item-value="SpeciesID"
                                v-model="search.speciesIDs"
                                label="Species"
                                clearable
                                multiple
                            ></v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-checkbox
                                label="Inactive Lots Only"
                                v-model="search.inactiveOnly"
                            ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="6" md="3" offset-md="3">
                            <v-btn block color="primary" :loading="loadingTableData" @click="loadTableData">Search</v-btn>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-btn
                                v-if="!$auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="addNewVenomLot({ Active: true })"
                            >
                                New Lot
                            </v-btn>
                        </v-col>

                    </v-row>

                    <v-row >
                        <v-col cols="12">
                            <v-alert v-if="activePoolsError" outlined :value="true" color="error" icon="error">
                                {{activePoolsError}}
                            </v-alert>
                            <v-data-table
                                :headers="headers"
                                :items="tableData"
                                :loading="loadingTableData"
                                :footer-props="footerProps"
                                :server-items-length="totalTableDataCount"
                                :sort-by.sync="pagination.sortBy"
                                :sort-desc.sync="pagination.descending"
                                :items-per-page.sync="pagination.rowsPerPage"
                                :page.sync="pagination.page"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template  v-slot:item="props">
                                    <tr :data-id="props.item.VenomLotID">
                                        <td>{{props.item.Barcode.toUpperCase()}}</td>
                                        <td>{{props.item.QALotNumbers}}</td>
                                        <td>{{$moment.utc(props.item.CreatedTime).local().format($constants.DATE_FORMAT)}}</td>
                                        <td>{{props.item.CreatedByFullName}} ({{props.item.CreatedByEmail}})</td>
                                        <td>{{props.item.SpeciesFullName}}</td>
                                        <td>{{props.item.TotalWeight || 0}}g</td>
                                        <td>{{props.item.Status}}</td>
                                        <td>
                                            <v-row no-gutters class="venom-lot-action-buttons-container-row">
                                                <v-col cols="6">
                                                    <v-btn
                                                        block
                                                        :color="(props.item.IsClosed ? 'info' : 'accent')"
                                                        @click="viewRecord(props.item.VenomLotID)"
                                                        v-if="!props.item.Inactive"
                                                    >
                                                        {{(props.item.IsClosed ? 'View' : 'Continue')}}
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-btn
                                                        v-if="!props.item.IsClosed&&!props.item.Inactive"
                                                        block
                                                        color="success"
                                                        @click="enterQA(props.item)"
                                                        
                                                    >
                                                        QA
                                                    </v-btn>
                                                    <v-btn
                                                        v-else-if="$auth.hasPermissions([$permissions.ACCESS_LEVELS.RELEASE_CERTIFICATE]) && props.item.VenomAnalysisCount > 0 && !props.item.Inactive"
                                                        block
                                                        color="accent"
                                                        @click="viewReleaseCertificate(props.item)"
                                                        
                                                    >
                                                        Certificate
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td>
                                            <v-btn
                                                class="ml-2"
                                                color="success"
                                                @click="inactiveVenomlot(props.item)"
                                                block
                                                v-if="!props.item.Inactive&&!props.item.TotalWeight"
                                            >
                                                Inactivate Pool
                                            </v-btn>
                                            <v-btn
                                                class="ml-2"
                                                color="success"
                                                :loading="activing"
                                                @click="activeVenomlot(props.item)"
                                                block
                                                v-if="props.item.Inactive&&permission"
                                            >
                                                Activate Pool
                                            </v-btn>
                                        </td>
                                        <td>
                                            <v-btn
                                                color="info"
                                                block
                                                @click="printBarcode(props.item.Barcode)"
                                                v-if="!props.item.Inactive&&permission"
                                            >
                                                Print Barcode
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="!loadingTableData" slot="no-data">
                                    <v-alert v-if="loadTableDataError" outlined :value="true" color="error" icon="error">
                                        {{loadTableDataError}}
                                    </v-alert>
                                    <v-alert v-if="!loadTableDataError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                </v-card>
            </v-col>

        </v-row>

        <VenomLotQADialog
            :venomLotID="enterQAForThisVenomLotID"
            :display="displayQADialog"
            @closeDialog="displayQADialog = false"
            @dataUpdated="loadTableData"
        >
        </VenomLotQADialog>

        <VenomLotInactiveDialog ref="inactiveDialog" @updated="loadTableData"> </VenomLotInactiveDialog>

    </v-container>
</template>

<script>

import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import moment from 'moment';

import util from '@/helpers/util';
import constants from 'comunet-btg-utah-repository-shared/constants';

import * as VenomPoolingAPI from "@/services/venomPoolingAPI";

import VenomLotQADialog from "./VenomLotQADialog";
import VenomLotInactiveDialog from "./VenomLotInactiveDialog.vue"

export default {
    components: {
        VenomLotQADialog,
        VenomLotInactiveDialog
    },
    props: [
        
    ],
    data() {
        return {
            search: {
                speciesIDs: [],
                inactiveOnly: false,
                openOnly: false,
                startDate: null,
                endDate: null
            },

            pagination: {
                rowsPerPage: 20, // default
                sortBy: "CreatedTime",
                descending: true,
                page: 1
            },

            showSearchStartDate: false,
            showSearchEndDate: false,

            activing:false,
            activePoolsError:null,

            loadingTableData: false,
            loadTableDataError: null,
            tableData: [],
            totalTableDataCount: 0,

            displayQADialog: false,
            enterQAForThisVenomLotID: null,

            headers: [
                {
                    text: "ID",
                    value: "Barcode"
                },
                {
                    text: "Venom Lot Number",
                    value: "QALotNumbers"
                },
                {
                    text: "Created Time",
                    value: "CreatedTime"
                },
                {
                    text: "Created By",
                    value: "CreatedByEmail"
                },
                {
                    text: "Species",
                    value: "SpeciesFullName"
                },
                {
                    text: "Total Weight",
                    value: "TotalWeight"
                },
                {
                    text: "Status",
                    value: "Status"
                },
                {
                    text: "",
                    sortable: false
                },
                {
                    text: "",
                    sortable: false
                },
                {
                    text: "",
                    sortable: false
                }
            ],

            footerProps: {
                'items-per-page-options': [5, 20, 50, 100]
            },
        };
    },
    computed: {
        title: function() {
            return this.$route.meta.title;
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesFullName"));
        },
        ...mapState("speciesStore", {
            loadingSpecies: state => state.loading
        }),
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        },
    },
    methods: {
        viewReleaseCertificate(venomLot) {
            this.$router.push({ name: 'releaseCertificate', params: { venomLotID: venomLot.VenomLotID }});
        },
        enterQA(venomLot) {
            this.enterQAForThisVenomLotID = venomLot.VenomLotID;
            this.displayQADialog = true;
        },
        viewRecord(venomLotID) {
            this.$router.push({ name: 'venomLot', params: { venomLotID: venomLotID }});
        },
        searchStartDateChanged(newValue) {
            this.search.startDate = newValue;

            this.showSearchStartDate = false;
        },
        searchEndDateChanged(newValue) {
            this.search.endDate = newValue;

            this.showSearchEndDate = false;
        },
        printBarcode(barcode) {
            let routeData = this.$router.resolve({name: 'printbarcode', params: { barcode: barcode }});
            window.open(routeData.href, '_blank');
        },
        async loadTableData() {
            try {
                this.displayQADialog = false;
                this.loadingTableData = true;

                const params = {
                    ...this.search,
                    ...this.pagination
                };

                if (params.startDate) {
                    params.startDate = moment(params.startDate).utc().format(constants.MYSQL_DATE_FORMAT_WITH_TIME);
                }
                
                if (params.endDate) {
                    params.endDate = moment(params.endDate).utc().format(constants.MYSQL_DATE_FORMAT_WITH_TIME);
                }

                const data = await VenomPoolingAPI.getVenomLots(params);
                this.totalTableDataCount = data.totalCount;
                this.tableData = data.data;
            }
            catch (e) {
                this.loadTableDataError = e;

                // eslint-disable-next-line no-console
                console.log(e);
            }
            finally {
                this.loadingTableData = false;
            }
        },
        addNewVenomLot() {
            this.$router.push({ name: 'venomLot'});
        },
        inactiveVenomlot(currentVenomlot) {
            this.$refs.inactiveDialog.showDialog(currentVenomlot.VenomLotID);
        },
        async activeVenomlot(currentVenomlot) {

            this.activing = true;
            try {
                var inactiveVenomlotRequest = {
                    VenomLotID: currentVenomlot.VenomLotID,
                    Inactive: false,
                };

                await VenomPoolingAPI.saveVenomLot(inactiveVenomlotRequest);
            }
            catch (e) {
                this.activePoolsError = e;
            }
            finally{
                this.activing = false;
                this.loadTableData();
            }

        },
    },
    async created() {
        this.$store.dispatch("speciesStore/loadSpecies");

        await this.loadTableData();
    },
    watch: {
        pagination: {
            async handler() {
                await this.loadTableData();
            },
            deep: true
        }
    },
};
</script>

<style lang="scss" scoped>
    #app {
        .venom-lot-action-buttons-container-row {
            .col:not(:first-child) {
                padding-left: 5px;
            }

            .col {
                .v-btn.reduced-padding {
                    padding-left: 4px;
                    padding-right: 4px;
                }
            }
        }
    }
</style>